
import { computed, defineComponent, ref, watchEffect } from 'vue';
import {
  SEND_CART_BUYS,
  SEND_FREIGHT_DETAILS,
  GET_ADDRESSES,
  GET_ADDRESS_VIA_CEP,
  NEW_ADDRESS,
  DELETE_ADDRESS,
  GET_ORDER_STATUS,
} from '@/store/type-actions';
import { useStore } from '@/store';
import { db } from '@/firebase';
import { query, collection, onSnapshot, getDocs, deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import ModalPayments from '../components/ModalPayments.vue';
import { PIX_QR_CODE } from '@/store/type-mutations';
import { brazilianStates } from '../helpers/brazilianStates'
import CheckoutCartItem from '@/components/checkout/CheckoutCartItem.vue';
import CheckoutAddressCard from '@/components/checkout/CheckoutAddressCard.vue';
import CheckoutFreightOptions from '@/components/checkout/CheckoutFreightOptions.vue';
import CheckoutValuesCard from '@/components/checkout/CheckoutValuesCard.vue';
import CheckoutPaymentCard from '@/components/checkout/CheckoutPaymentCard.vue';

export default defineComponent({
  name: 'buyingScreen',
  components: {
    ModalPayments,
    CheckoutCartItem,
    CheckoutAddressCard,
    CheckoutFreightOptions,
    CheckoutValuesCard,
    CheckoutPaymentCard,
  },

  data() {
    return {
      messageFailPayment: '',
      creditCardChoice: false,
      pixChoice: false,
      eCashChoice: false,
      showAddress: false,
      months: [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12'
      ],
      address: {
        city: '',
        complement: '',
        neighborhood: '',
        number: '',
        state: '',
        street: '',
        zipCode: '',
      },
      cartItems: [
          {
            product_id: '',
            colorId: 0,
            color: 0,
            price: 0,
            product_option: 0,
            promotional_price: '',
            size: '',
          },
        ],
      loading: 'waiting',
      totalPrice: 0,
      dataEcash: '00,00',
      dataSaldo: '00,00',
      dataPix: '00,00',
      dataCreditCard: '00,00',
      cep: '',
      newAddressCep: '',
      newAddressNumber: '',
      newAddressComplement: '',
      showNewAddressForm: false,
      savingAddress: false,
      deletingAddressId: 0,
      pixStatusInterval: 0,
      selectedFreight: '',
      freightName: '',
      freightOptions: [
        {
          Codigo: '',
          Nome: '',
          Prazo: 0,
          Valor: 0,
        },
      ],
      selectedAddress: {
        type: '',
        id: 0
      } as any,
      prompt: 0,
      eCashSaldo: false,
      showPaymentResult: 'waiting',
      loadingPayment: true,
      restartingQR: false,
      firebase: process.env.VUE_APP_FIREBASE_STORE || 'CartItemsHomologacao',
      pixTimer: process.env.VUE_APP_PIX_TIMER || 0,
      states:  brazilianStates,
      errorMessage: null as string | null,
   };
  },

  computed: {
    addressDestination(): string {
      return this.address.city ? `${this.address.city}/${this.address.state}` : '';
    },
    checkoutUserAddresses(): { endereco_cadastro: any, endereco_entrega: any[] } {
      const cadastro = this.store.state.userAddresses.endereco_cadastro;
      const loginAddress = this.store.state.login.data.adress || {};

      return {
        endereco_cadastro: cadastro?.id || cadastro?.zip_code ? cadastro : loginAddress,
        endereco_entrega: this.store.state.userAddresses.endereco_entrega || [],
      };
    },
    paymentOptions(): Array<any> {
      return [
        {
          key: 'ecash',
          label: 'eCash + Saldo',
          badge: 'e',
          color: 'bg-amber-500',
          image: 'img/LogoIcon.svg',
          checked: this.eCashChoice,
          disabled: (this.pixChoice && this.creditCardChoice) || (this.eCashValue + this.userSaldo == 0),
        },
        {
          key: 'pix',
          label: 'Pix',
          badge: 'P',
          color: 'bg-teal-500',
          image: 'img/pix.png',
          checked: this.pixChoice,
          disabled: this.eCashChoice && this.creditCardChoice,
        },
        {
          key: 'creditCard',
          label: 'Cartão de crédito',
          badge: 'C',
          color: 'bg-orange-500',
          image: 'img/card.png',
          checked: this.creditCardChoice,
          disabled: this.pixChoice && this.eCashChoice,
        },
      ];
    },
  },

  methods: {

    formatPaymentValue(value: number): string {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value || 0);
    },

    togglePayment(type: string, checked: boolean) {
      if (type === 'ecash') {
        this.eCashChoice = checked;
        if (!checked) this.dataEcash = '00,00';
      }

      if (type === 'pix') {
        this.pixChoice = checked;
        if (!checked) this.dataPix = '00,00';
      }

      if (type === 'creditCard') {
        this.creditCardChoice = checked;
        if (!checked) this.dataCreditCard = '00,00';
      }
    },

    updatePaymentForm(field: 'typeCard' | 'month' | 'year' | 'cep' | 'state', value: string) {
      this.form[field] = value;
    },

    syncPaymentValue() {
      const selected = [this.eCashChoice, this.pixChoice, this.creditCardChoice].filter(Boolean).length;
      if (selected !== 1) return;

      if (this.eCashChoice) this.dataEcash = this.formatPaymentValue(this.totalPrice);
      if (this.pixChoice) this.dataPix = this.formatPaymentValue(this.totalPrice);
      if (this.creditCardChoice) this.dataCreditCard = this.formatPaymentValue(this.totalPrice);
    },

    selectFreightOption(option: any) {
      this.getSelectedFreight(option.Valor, option.Codigo, option.Prazo, option.Nome);
    },

    selectCheckoutAddress(payload: any) {
      this.selectedAddress = { type: payload.type, id: payload.id };
      this.cep = payload?.zip_code || '';
      this.newAddressCep = '';
      this.newAddressNumber = payload?.number || '';
      this.newAddressComplement = payload?.complement || '';
      this.showNewAddressForm = false;
      this.address = {
        city: payload?.city || '',
        complement: payload?.complement || '',
        state: payload?.state || '',
        neighborhood: payload?.neighborhood || '',
        street: payload?.street || '',
        zipCode: payload?.zip_code || '',
        number: payload?.number || '',
      };
      this.applyBillingAddress();
      this.calculateFreight(false);
    },

    async searchTypedAddress() {
      this.cep = this.newAddressCep;
      this.newAddressNumber = '';
      this.newAddressComplement = '';
      await this.calculateFreight(true);
    },

    async useTypedAddress() {
      if (this.savingAddress || !this.cep || !this.address.street || !this.address.city || !this.newAddressNumber) {
        return;
      }

      this.savingAddress = true;
      this.address.number = this.newAddressNumber;
      const newAddress = {
        id_client: this.loginId,
        zip_code: this.cep,
        street: this.address.street,
        number: this.newAddressNumber,
        complement: this.newAddressComplement,
        neighborhood: this.address.neighborhood,
        city: this.address.city,
        state: this.address.state,
      };

      try {
        const created = await this.store.dispatch(NEW_ADDRESS, newAddress).then((res) => res.data);
        await this.store.dispatch(GET_ADDRESSES, this.loginId);

        const savedAddress = this.store.state.userAddresses.endereco_entrega.find((item: any) => {
          return item.id == created?.id || (
            item.zip_code == newAddress.zip_code &&
            item.street == newAddress.street &&
            item.number == newAddress.number
          );
        }) || created;

        this.selectedAddress = { type: 'entrega', id: savedAddress.id };
        this.cep = savedAddress.zip_code || newAddress.zip_code;
        this.address = {
          city: savedAddress.city || newAddress.city,
          complement: savedAddress.complement || newAddress.complement,
          state: savedAddress.state || newAddress.state,
          neighborhood: savedAddress.neighborhood || newAddress.neighborhood,
          street: savedAddress.street || newAddress.street,
          zipCode: savedAddress.zip_code || newAddress.zip_code,
          number: savedAddress.number || newAddress.number,
        };
        this.applyBillingAddress();
        this.newAddressCep = '';
        this.showNewAddressForm = false;
      } finally {
        this.savingAddress = false;
      }
    },

    async deleteAddress(address: any) {
      if (this.deletingAddressId || address.type !== 'entrega') return;

      this.deletingAddressId = address.id;
      try {
        await this.store.dispatch(DELETE_ADDRESS, address.id);
        await this.store.dispatch(GET_ADDRESSES, this.loginId);

        if (this.selectedAddress.type === 'entrega' && this.selectedAddress.id === address.id) {
          const userAdr = this.store.state.userAddresses.endereco_cadastro || this.store.state.login.data.adress;
          this.selectedAddress = { type: 'cadastro', id: userAdr?.id || 0 };
          this.cep = userAdr?.zip_code || '';
          this.address = {
            city: userAdr?.city || '',
            complement: userAdr?.complement || '',
            state: userAdr?.state || '',
            neighborhood: userAdr?.neighborhood || '',
            street: userAdr?.street || '',
            zipCode: userAdr?.zip_code || '',
            number: userAdr?.number || '',
          };
          this.applyBillingAddress();
          await this.calculateFreight(false);
        }
      } finally {
        this.deletingAddressId = 0;
      }
    },

    async changeCartQuantity(product: any, type: 'plus' | 'minus') {
      const docRef = doc(db, this.firebase + this.loginId, product.product_id + product.color + product.size);
      const checkDoc = await getDoc(docRef);
      if (!checkDoc.exists()) return;

      const unitPrice = (Number(product.price) || 0) / (Number(product.quantity) || 1);
      let newQuantity = type == 'plus' ? checkDoc.data()?.quantity + 1 : checkDoc.data()?.quantity - 1;

      if (newQuantity < 1) newQuantity = 1;

      await updateDoc(docRef, {
        quantity: newQuantity,
        price: newQuantity * unitPrice,
      });
    },

    removeCartItem(product: any) {
      return deleteDoc(doc(db, this.firebase + this.loginId, product.product_id + product.color + product.size));
    },

    clearPixStatusPolling() {
      if (this.pixStatusInterval) {
        clearInterval(this.pixStatusInterval);
        this.pixStatusInterval = 0;
      }
    },

    async clearCheckoutCartItems() {
      const removableItems = this.cartItems.slice(1);
      await Promise.all(removableItems.map((item: any) => {
        return deleteDoc(doc(db, this.firebase + this.loginId, item.product_id + item.color + item.size));
      }));
    },

    async checkPixOrderStatus(localOrderId: string) {
      try {
        const orderStatus = await this.store.dispatch(GET_ORDER_STATUS, localOrderId);
        const normalizedStatus = (orderStatus?.status || '').toLowerCase();

        if (normalizedStatus == 'approved') {
          this.clearPixStatusPolling();
          await this.clearCheckoutCartItems();
          this.showPaymentResult = 'success';
          return;
        }

        if (normalizedStatus == 'cancel') {
          this.clearPixStatusPolling();
          this.errorMessage = 'O pagamento Pix foi cancelado ou recusado.';
          this.showPaymentResult = 'error';
        }
      } catch (error) {
        console.error('Erro ao consultar status do Pix:', error);
      }
    },

    startPixStatusPolling(localOrderId: string) {
      if (!localOrderId) return;

      this.clearPixStatusPolling();
      this.checkPixOrderStatus(localOrderId);
      this.pixStatusInterval = parseInt(setInterval(() => {
        this.checkPixOrderStatus(localOrderId);
      }, 5000).toString());
    },

    getStateFormValue(state: string): string {
      const stateValue = (state || '').toLowerCase();
      const foundState = this.states.find((stt: { state: string, acronym: string }) => {
        return stt.state.toLowerCase() == stateValue || stt.acronym.toLowerCase() == stateValue;
      });

      return foundState?.state.toLowerCase() || stateValue;
    },

    applyBillingAddress() {
      this.form.cep = this.cep || this.address.zipCode || '';
      this.form.state = this.getStateFormValue(this.address.state);
      this.personalInfo[2].value = this.address.city || '';
      this.personalInfo[3].value = this.address.neighborhood || '';
      this.personalInfo[4].value = this.address.street || '';
      this.personalInfo[5].value = this.address.number || '';
      this.personalInfo[6].value = this.address.complement || '';
    },

    getPaymentErrorMessage(errorData: any): string {
      if (!errorData) return 'Erro desconhecido.';
      if (typeof errorData === 'string') return errorData;
      if (errorData.Error) return errorData.Error;
      if (errorData.error) return errorData.error;
      if (errorData.message) return errorData.message;
      if (errorData.data?.Error) return errorData.data.Error;
      if (errorData.data?.message) return errorData.data.message;

      return 'Não foi possível processar o pagamento. Verifique os dados e tente novamente.';
    },

    getDefaultCheckoutAddress() {
      const cadastro = this.store.state.userAddresses.endereco_cadastro;
      if (cadastro?.id || cadastro?.zip_code) return cadastro;

      return this.store.state.login.data.adress || {};
    },

    applyDefaultCheckoutAddress() {
      const userAdr = this.getDefaultCheckoutAddress();
      this.selectedAddress = {type: 'cadastro', id: userAdr?.id || 0}

      this.address = {
        city: userAdr?.city || '',
        complement: userAdr?.complement || '',
        state: userAdr?.state || '',
        neighborhood: userAdr?.neighborhood || '',
        street: userAdr?.street || '',
        zipCode: userAdr?.zip_code || userAdr?.zipCode || '',
        number: userAdr?.number || ''
      }
      this.cep = userAdr?.zip_code || userAdr?.zipCode || this.user.CEP || ''
      this.newAddressNumber = userAdr?.number || ''
      this.newAddressComplement = userAdr?.complement || ''
      this.newAddressCep = ''
      this.showNewAddressForm = false
      this.applyBillingAddress();
    },

    getStateAcronym(state: string): string {
      return this.states.find((stt: { state: string, acronym: string }) => stt.state.toLowerCase() == state)?.acronym || ''
    },

   checkCreditCardForm(): boolean {
      
      if (this.form.typeCard == '') {
        this.errors.typeCard = 'Informe o tipo do cartão'
      } else {
        this.errors.typeCard = ''
      }

      if (!this.cardInfo[0].value.match(/[Àa-üZ]+\s[Àa-üZ\s]+/i)) {
        this.cardInfo[0].error = 'Informe nome e sobrenome'
      } else {
        this.cardInfo[0].error = ''
      }

      if (!this.cardInfo[1].value.match(/[\d]{3}\.[\d]{3}\.[\d]{3}-[\d]{2}/)) {
        this.cardInfo[1].error = 'Informe o cpf corretamente'
      } else {
        this.cardInfo[1].error = ''
      }

      if (!this.cardInfo[2].value.match(/[\d]{4}\s[\d]{4}\s[\d]{4}\s[\d]{4}/)) {
      this.cardInfo[2].error = 'Informe o número do cartão corretamente'
      } else {
        this.cardInfo[2].error = ''
      }

      if (!this.cardInfo[3].value.match(/[\d]{3}/)) {
        this.cardInfo[3].error = 'Informe o CVV do cartão'
      } else {
        this.cardInfo[3].error = ''
      }

      if (!this.form.month.match(/[\d]{2}/)) {
        this.errors.month = 'Informe o mês de vencimento do cartão'
      } else {
        this.errors.month = ''
      }

      if (!this.form.year.match(/[\d]{2}/)) {
        this.errors.year = 'Informe o ano de vencimento do cartão'
      } else {
        this.errors.year = ''
      }

      if (!this.personalInfo[0].value.match(/[Àa-üZ0-9_.+-]+@[Àa-üZ0-9_.+-].[Àa-üZ0-9_.+-]/gim)) {
        this.personalInfo[0].error = 'Informe um email válido'
      } else {
        this.personalInfo[0].error = ''
      }

      if (!this.personalInfo[1].value.match(/\(\d\d\)\s9\s\d{4}-\d{4}/)) {
        this.personalInfo[1].error = 'Informe um telefone válido'
      } else {
        this.personalInfo[1].error = ''
      }

      if (!this.form.cep.match(/\d{5}-\d{3}/)) {
        this.errors.cep = 'Informe o cep corretamente'
      } else {
        this.errors.cep = ''
      }

      if (this.form.state == '') {
        this.errors.state = 'Informe um estado'
      } else {
        this.errors.state = ''
      }

      if (this.personalInfo[2].value == '') {
        this.personalInfo[2].error = 'Informe uma cidade'
      } else {
        this.personalInfo[2].error = ''
      }

      if (this.personalInfo[3].value == '') {
        this.personalInfo[3].error = 'Informe um bairro'
      } else {
        this.personalInfo[3].error = ''
      }

      if (this.personalInfo[4].value == '') {
        this.personalInfo[4].error = 'Informe uma rua'
      } else {
        this.personalInfo[4].error = ''
      }

      if (this.personalInfo[5].value == '') {
        this.personalInfo[5].error = 'Informe um número residencial'
      } else {
        this.personalInfo[5].error = ''
      }

      if (this.personalInfo[5].value == '' ||
      this.personalInfo[4].value == ''||
      this.personalInfo[3].value == '' ||
      this.personalInfo[2].value == '' ||
      this.form.state == ''||
      !this.form.cep.match(/\d{5}-\d{3}/) ||
      !this.personalInfo[1].value.match(/\(\d\d\)\s9\s\d{4}-\d{4}/) ||
      !this.personalInfo[0].value.match(/[Àa-üZ0-9_.+-]+@[Àa-üZ0-9_.+-].[Àa-üZ0-9_.+-]/gim) ||
      !this.form.year.match(/[\d]{2}/) ||
      !this.form.month.match(/[\d]{2}/) ||
      !this.cardInfo[3].value.match(/[\d]{3}/) ||
      !this.cardInfo[2].value.match(/[\d]{4}\s[\d]{4}\s[\d]{4}\s[\d]{4}/) ||
      !this.cardInfo[1].value.match(/[\d]{3}\.[\d]{3}\.[\d]{3}-[\d]{2}/) ||
      !this.cardInfo[0].value.match(/[Àa-üZ]+\s[Àa-üZ\s]+/i) ||
      this.form.typeCard == '') {
        return false
      }

      return true
    },

    getAddressCadastro(payload: any) {
      this.selectedAddress = {type: 'cadastro', id: payload.id}
      this.cep = payload?.zip_code || ''
      this.calculateFreight()

      this.address = {
        city: payload?.city || '',
        complement: payload?.complement || '',
        state: payload?.state?.toLowerCase() || '',
        neighborhood: payload?.neighborhood || '',
        street: payload?.street || '',
        zipCode: payload?.zipCode || '',
        number: payload?.number || ''
      }
    },

    getAddressEntrega(payload: any) {
      this.selectedAddress = {type: 'entrega', id: payload.id}
      this.cep = payload?.zip_code || ''
      this.calculateFreight()
      this.address = {
        city: payload?.city || '',
        complement: payload?.complement || '',
        state: payload?.state?.toLowerCase() || '',
        neighborhood: payload?.neighborhood || '',
        street: payload?.street || '',
        zipCode: payload?.zipCode || '',
        number: payload?.number || ''
      }
    },

    checkForm(): boolean {
      this.messageFailPayment = '';
      let eCash = parseFloat(this.dataEcash.replaceAll('.','').replace(',', '.')) || 0;
      let pix = parseFloat(this.dataPix.replaceAll('.','').replace(',', '.')) || 0;
      let creditCard = parseFloat(this.dataCreditCard.replaceAll('.','').replace(',', '.')) || 0;

      if (eCash + pix + creditCard > this.totalPrice) {
        const exceededValue = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format((eCash + pix + creditCard) - this.totalPrice)

                this.messageFailPayment = `Valor do pagamento não confere. Valor ultrapassado ${exceededValue}`
        return false
      }

      if (eCash + pix + creditCard < this.totalPrice) {
        const missingValue = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format(this.totalPrice - (eCash + pix + creditCard))
     
        this.messageFailPayment = `Valor do pagamento não confere. Valo em falta ${missingValue}`
        return false
      }
  
      if (creditCard != 0) {
        return this.checkCreditCardForm()
      }
      return true
    },

    showMissingValue(): string {
      let eCash = parseFloat(this.dataEcash.replaceAll('.','').replace(',', '.')) || 0;
      let pix = parseFloat(this.dataPix.replaceAll('.','').replace(',', '.')) || 0;
      let creditCard = parseFloat(this.dataCreditCard.replaceAll('.','').replace(',', '.')) || 0;
      
      if (eCash + pix + creditCard <= this.totalPrice) {
      const missingValue = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format(this.totalPrice - (eCash + pix + creditCard))


        return `Valor em falta ${missingValue}`
      }

      if (eCash + pix + creditCard > this.totalPrice) {

        const exceededValue = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format((eCash + pix + creditCard) - this.totalPrice)


        return `Valor ultrapassado ${exceededValue}`
      }

      return ''
    },

    async finishPayment() {
      const eCash = parseFloat(this.dataEcash.replaceAll('.','').replace(',', '.')) || 0;
      const pix = parseFloat(this.dataPix.replaceAll('.','').replace(',', '.')) || 0;
      const creditCard = parseFloat(this.dataCreditCard.replaceAll('.','').replace(',', '.')) || 0;

      let payments: unknown[] = [];
      console.log('ECash:', eCash);
      console.log('Pix:', pix);
      console.log('Credit Card:', creditCard);
      console.log('Total Price:', this.totalPrice);
      console.log('Sum of Payments:', eCash + pix + creditCard);
      if (eCash + pix + creditCard !== this.totalPrice) {
        this.errors.valueError = 'Os valores não batem';
      }

      if (eCash != 0) {
        if ((eCash > this.eCashValue) && (this.eCashValue !== 0)) {
          payments.push({
            payment_type: 1,
            payment_value: this.eCashValue,
          });

          payments.push({
            payment_type: 4,
            payment_value: eCash - this.eCashValue,
          });
        }

        if (this.eCashValue == 0) {
          payments.push({
            payment_type: 4,
            payment_value: eCash,
          });
        }

        if (eCash < this.eCashValue) {
          payments.push({
            payment_type: 1,
            payment_value: eCash,
          });
        }
      }

      if (creditCard != 0) {
        payments.push({
          payment_type: 3,
          payment_value: creditCard,
          card_type: this.form.typeCard,
          card_owner_name: this.cardInfo[0].value,
          cpf: this.cardInfo[1].value,
          card_number: this.cardInfo[2].value,
          cvv: this.cardInfo[3].value,
          validate_month: this.form.month,
          validate_year: this.form.year,
          personal_data: [
            {
              email: this.personalInfo[0].value,
              number: this.personalInfo[1].value,
              cep: this.form.cep,
              state: this.getStateAcronym(this.form.state),
              city: this.personalInfo[2].value,
              neighborhood: this.personalInfo[3].value,
              street: this.personalInfo[4].value,
              residence_number: this.personalInfo[5].value,
              complement: this.personalInfo[6].value,
            },
          ],
        });
      }

      if (pix != 0) {
        payments.push({
          payment_type: 2,
          payment_value: pix,
        });
      }

      if (this.checkForm()) {
        const q = query(collection(db, this.firebase + this.loginId));
        const getAllItems = await getDocs(q);
        let items: Array<any> = [];
        let item1 = {};

        getAllItems.forEach(async (item: { data(): unknown }) => {
          let parsed = JSON.parse(JSON.stringify(item.data()));

          item1 = {
            product_id: parsed.product_id,
            product_option: parsed.product_option,
            quantity: parsed.quantity,
            value: parsed.price,
            color: parsed.color_id,
            size: parsed.size,
            colorNumber: parsed.color
          };
          items.push(item1);
        });

        const cart = {
          user_id: this.loginId,
          final_value: this.totalPrice,
          products_value: this.finalProductPrice,
          client_payment: pix + creditCard + eCash,
          send: JSON.parse(JSON.stringify(this.selectedAddress)),
          products: items,
          freight: {
            freight_value: this.fretePrice,
            prompt: this.prompt,
            freight_code: this.selectedFreight,
            freight_name: this.freightName,
          },
          payments_all: [
            {
              payment: payments,
            },
          ],
        };

        this.loadingPayment = true;
        this.showPaymentResult = ''
        try {
         const cartPayload = await this.store.dispatch(SEND_CART_BUYS, cart).then((res) => res.data.data)
          if (cartPayload?.pix) {
            const pixRaw = cartPayload.pix[0];

            const pix = typeof pixRaw === 'string'
              ? JSON.parse(pixRaw)
              : pixRaw;
            this.showPaymentResult = 'pix';
            this.loadingPayment = false;
            console.log(pix);
            console.log(pix.qr_code);
            this.store.commit(PIX_QR_CODE, {
              status: pix.status,
              qrCode: pix.qr_code,
              price: pix.price,
              id: pix.transaction_id,
              localOrderId: pix.local_order_id,
              timer: this.pixTimer
            })
            this.startPixStatusPolling(pix.local_order_id);
          } else if (cartPayload?.card?.erro) {
            this.showPaymentResult = 'error';
            this.loadingPayment = false;
            const mensagemCompleta = cartPayload.card.erro?.message || cartPayload.card.erro || 'Erro no processamento do cartão.';
            this.errorMessage = (mensagemCompleta?.length??0) > 1000 
              ? mensagemCompleta.substring(0, 1000) + '...' 
              : mensagemCompleta;
          } else if (cartPayload?.card?.approved) {
            await this.clearCheckoutCartItems();
            this.showPaymentResult = 'success';
            this.loadingPayment = false;
          } else if (cartPayload?.enerzee?.status == 200) {
            await this.clearCheckoutCartItems();
            this.showPaymentResult = 'success';
            this.loadingPayment = false;
          } else {
            this.showPaymentResult = 'error';
            this.errorMessage = 'A resposta do pagamento veio em um formato inesperado.';
            this.loadingPayment = false
          }

        } catch (err: any) {
          this.showPaymentResult = 'error';
          this.loadingPayment = false;

          if (err.response && err.response.data) {
            console.error('Erro 500 body:', err.response.data);
            this.errorMessage = this.getPaymentErrorMessage(err.response.data);
          } else {
            console.error('Erro inesperado:', err);
            this.errorMessage = err.message || 'Erro desconhecido.';
          }
        }

     }

    },

    eCashMask() {
      if (this.dataEcash != '') {
        let oldValueCash = this.dataEcash
          .replaceAll('.', '')
          .replaceAll(',', '');
        let checkCash = oldValueCash.replace(/^0\d+/, oldValueCash.substr(1));
        let eCashComma = checkCash.replace(/(\d{2})$/gim, ',$1');
        let newValueCash = eCashComma.replace(
          /\B(?=(\d{3})+(?!\d)(?=,))/g,
          '.'
        );
        this.dataEcash = newValueCash;
      } else {
        this.dataEcash = '00,00';
      }
    },

    pixMask() {
      if (this.dataPix != '') {
        let oldValuePix = this.dataPix.replaceAll('.', '').replaceAll(',', '');
        let checkPix = oldValuePix.replace(/^0\d+/, oldValuePix.substr(1));
        let pixComma = checkPix.replace(/(\d{2})$/gim, ',$1');
        let newValuePix = pixComma.replace(/\B(?=(\d{3})+(?!\d)(?=,))/g, '.');

        this.dataPix = newValuePix;
      } else {
        this.dataPix = '00,00';
      }
    },

    creditCardMask() {
      if (this.dataCreditCard !== '') {
        let oldCreditCard = this.dataCreditCard
          .replaceAll('.', '')
          .replaceAll(',', '');
        let checkCreditCard = oldCreditCard.replace(
          /^0\d+/,
          oldCreditCard.substr(1)
        );
        let creditCardComma = checkCreditCard.replace(/(\d{2})$/gim, ',$1');
        let newCreditCardValue = creditCardComma.replace(
          /\B(?=(\d{3})+(?!\d)(?=,))/g,
          '.'
        );

        this.dataCreditCard = newCreditCardValue;
      } else {
        this.dataCreditCard = '00,00';
      }
    },
     
     getCartProducts() {
      const q = query(collection(db, this.firebase + this.loginId));

      onSnapshot(q, (query) => {
        this.totalPrice = 0
        this.finalProductPrice = 0
        this.cartItems = [
          {
            product_id: '',
            colorId: 0,
            color: 0,
            price: 0,
            product_option: 0,
            promotional_price: '',
            size: '',
          },
        ];
        query.forEach((doc) => {

        const parsed = JSON.parse(JSON.stringify(doc.data()));
            const price = parseFloat(parsed.price) || 0;
            this.totalPrice += Number(price.toFixed(2));
            this.finalProductPrice += price;
          this.cartItems.push(JSON.parse(JSON.stringify(doc.data())));
        });
      });
    },

    closePixPayment() {
      if (this.showPaymentResult == 'success') {
        this.$router.push('/')
      }
      this.clearPixStatusPolling();
      this.showPaymentResult = 'waiting';
    },

    async calculateFreight(updateAddress = true) {
      this.loading = 'loading';
      this.selectedFreight = '';
      this.prompt = 0;
      this.fretePrice = 0;
      const q = query(collection(db, this.firebase + this.loginId));
      const getAllItems = await getDocs(q);
      let freightItems = [{}];
      const cepDestino = this.cep.replace(/\D/g, '');

      this.freightOptions = [
        {
          Codigo: '',
          Nome: '',
          Prazo: 0,
          Valor: 0,
        },
        {
          Codigo: '95X15',
          Nome: 'Retire na loja',
          Prazo: 0,
          Valor: 0,
        },
      ];

      if (cepDestino.length !== 8) {
        this.loading = '';
        if (updateAddress) this.showNewAddressForm = false;
        return;
      }

      const viaCepAddress = await this.store.dispatch(GET_ADDRESS_VIA_CEP, cepDestino);
      if (updateAddress && !viaCepAddress?.erro) {
        this.address = {
          city: viaCepAddress.localidade || '',
          complement: '',
          state: viaCepAddress.uf || '',
          neighborhood: viaCepAddress.bairro || '',
          street: viaCepAddress.logradouro || '',
          zipCode: viaCepAddress.cep || this.cep,
          number: '',
        };
        this.showNewAddressForm = true;
      } else if (updateAddress) {
        this.showNewAddressForm = false;
      }
        
      getAllItems.forEach((doc: { data(): unknown }) => {
        let parsed = JSON.parse(JSON.stringify(doc.data()));
        let item = {
          quantidade: parsed.quantity || 1,
          peso: parsed.weight || 1,
          comprimento: parsed.comprimento || 10,
          altura: parsed.height || 10,
          largura: parsed.width || 10,
        };
        freightItems.push(item);
      });

      if (freightItems.length === 1) {
        this.loading = 'loaded';
        this.getSelectedFreight(0, '95X15', 0, 'Retire na loja');
        return;
      }
      
      try {
        await this.store
          .dispatch(SEND_FREIGHT_DETAILS, {
            cep_destino: cepDestino,
            item: freightItems.slice(1),
          })
          .then((res) => {
            for (let rrr = 0; rrr < res.data.length; rrr++) {
              const data = res.data[rrr];
              if (data?.Codigo !== '95X15') {
                this.freightOptions.push(data);
              }
              this.loading = 'loaded';
            }
          });
      } catch (err: unknown) {
        this.loading = 'loaded';
      }
    },
    getSelectedFreight(
      value: number | string,
      selectedFreight: string,
      prompt: number,
      name: string
    ) {  
      const freightValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      localStorage.setItem('freightValue', freightValue.toString());
      localStorage.setItem('finalProductPriceValue', this.finalProductPrice.toString());
      this.fretePrice = freightValue;
      this.selectedFreight = selectedFreight;
      this.prompt = prompt;
      this.freightName = name;
      this.calculateFinalPrice();
      this.syncPaymentValue();
    },

    calculateFinalPrice() {
      // Get the saved freight value from localStorage
      const freightValue = localStorage.getItem('freightValue');
      const finalProductPriceValue = localStorage.getItem('finalProductPriceValue');

      if (freightValue && finalProductPriceValue) {
      const parsedFreightValue = parseFloat(freightValue);
      const parsedFinalProductPriceValue = parseFloat(finalProductPriceValue);
      this.totalPrice = Number((parsedFreightValue + parsedFinalProductPriceValue).toFixed(2)); // Recalculate the total price by adding the freight value

      localStorage.removeItem('freightValue');
      }
    },

    getYears() {
      const date = new Date()
      const dates = [
        date.getFullYear(),
        date.getFullYear() + 1,
        date.getFullYear() + 2,
        date.getFullYear() + 3,
        date.getFullYear() + 4,
        date.getFullYear() + 5,
        date.getFullYear() + 6,
        date.getFullYear() + 7,
        date.getFullYear() + 8,
        date.getFullYear() + 9,
        date.getFullYear() + 10,
      ]

      return dates
    }
  },

  async mounted() {
    watchEffect(() => {
      if (!this.creditCardChoice) {
        this.dataCreditCard = '00,00';
      }

      if (!this.pixChoice) {
        this.dataPix = '00,00';
      }

      if (!this.eCashChoice) {
        this.dataEcash = '00,00';
      }

      const eCash = parseFloat(this.dataEcash.replaceAll('.','').replace(',', '.')) || 0;

      if (eCash > this.userSaldo + this.eCashValue) {
          this.dataEcash = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
          }).format(this.userSaldo + this.eCashValue).replace('R$','')
      }

    }); 
    this.getCartProducts();
    this.applyDefaultCheckoutAddress();

    const addressesRequest = this.store.dispatch(GET_ADDRESSES, this.loginId).then(() => {
      if (this.selectedAddress.type == 'cadastro') {
        this.applyDefaultCheckoutAddress();
      }
    });

    if (this.cep) {
      await Promise.all([addressesRequest, this.calculateFreight(false)]);
      return;
    }

    await addressesRequest;
    this.applyDefaultCheckoutAddress();
    await this.calculateFreight(false)
  },

  setup() {
    const store = useStore();
    const user = store.state.user
    const loginData = store.state.login.data
    const userAddress: any = loginData.adress || {}
    const finalProductPrice = ref(0);
    const fretePrice = ref(0);
    const eCashValue = ref(user.SaldoECash || 0);
    const userSaldo = ref(user.Saldo || 0)
    const loginId = store.state.login.data.id
    const cardInfo = ref([
         {
          label: 'Nome e Sobrenome',
          placeholder: 'Nome e Sobrenome',
          mask: '',
          id: 'nameAndSurname',
          value: '',
          error: '',
          divStyle: 'flex flex-col w-full gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'CPF do cartão',
          placeholder: '000.000.000-00',
          mask: '###.###.###-##',
          id: 'cardCPF',
          value: '',
          error: '',
          divStyle: 'flex flex-col w-full gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',

        },
        {
          label: 'Número do cartão',
          placeholder: 'Número do cartão',
          mask: '#### #### #### ####',
          id: 'cardNumber',
          value: '',
          error: '',
          divStyle: 'flex flex-col w-9/12 gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',

        },
        {
          label: 'CVV',
          placeholder: 'CVV',
          mask: '###',
          id: '123',
          value: '',
          error: '',
          divStyle: 'flex flex-col w-2/12 gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        }
      ])

     const personalInfo = ref([
        {
          label: 'Email',
          placeholder: 'email@exemplo.com',
          mask: '',
          id: 'email',
          value: '',
          error: '',
          divStyle: 'flex flex-col w-full gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'Número',
          placeholder: '(00) 9 0000-0000',
          mask: '(##) 9 ####-####',
          id: 'cellphone',
          value: '',
          error: '',
          divStyle: 'flex flex-col w-full gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'Cidade',
          placeholder: 'Cidade',
          mask: '',
          id: 'city',
          value: user.NomeCidade || userAddress.city || '',
          error: '',
          divStyle: 'flex flex-col w-1/2 gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'Bairro',
          placeholder: 'Bairro',
          mask: '',
          id: 'neighborhood',
          value: user.Bairro || userAddress.neighborhood || '',
          error: '',
          divStyle: 'flex flex-col w-1/2 gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'Rua',
          placeholder: 'Rua',
          mask: '',
          id: 'street',
          value: user.Endereco || userAddress.street || '',
          error: '',
          divStyle: 'flex flex-col w-1/2 gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'Número de residência',
          placeholder: 'Número',
          mask: '',
          id: 'residenceNumber',
          value: user.Numero || userAddress.number || '',
          error: '',
          divStyle: 'flex flex-col w-1/2 gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },
        {
          label: 'Complemento',
          placeholder: 'Complemento',
          mask: '',
          id: 'complement',
          value: user.Complemento || '',
          divStyle: 'flex flex-col w-full gap-1 break-word',
          inputStyle: 'p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none',
        },

      ])

      const form = ref({
        typeCard: '',
        month: '',
        year: '',
        cep: user.CEP || userAddress.zip_code || '',
        state: (user.NomeEstado || userAddress.state || '').toLowerCase(),
      })

      const errors = ref({
        valueError: '',
        typeCard: '',
        month: '',
        year: '',
        cep: '',
        state: '',
      })
  
    return {
      store,
      user,
      loginId,
      finalProductPrice,
      fretePrice,
      eCashValue,
      userSaldo,
      cardInfo,
      personalInfo,
      form,
      errors
    };
  },
});
